import { useEffect, useState } from "react"
import { Container } from "@mui/material"
import { SignupFormContext, SignupFormData } from "../../../components/Context/SignupFormContext"
import { StoreProvider } from "../../../store/signup/UserSignupStore"
import { defaultMyInfoData, MyInfoContextProvider } from "../../../services/myInfo/myInfo"
import { initialState, signupReducer } from '../../../store/signup/SignupReducer'
import { I18nextProvider } from 'react-i18next'
import i18config from '../../../helpers/i18n'
import { ThemeProvider } from '@mui/material'
import theme from '../../../helpers/theme'
import DisclaimerPage from "../DisclaimerPage/DisclaimerPage"
import SignupFormPage from "../SignupFormPage/SignupFormPage"
import ReviewPage from "../ReviewPage/ReviewPage"
import CallbackPage from "../CallbackPage/CallbackPage"
import TermsAndConditionsPage from "../TermsAndConditionPage/TermsAndConditionPage"
import AcknowledgementPage from "../AcknowledgementPage/AcknowledgementPage"
import PaymentPage from "../PaymentPage/PaymentPage"
import IntroductionPage from "../IntroductionPage/IntroductionPage"
import DraftPage from "../DraftPage/DraftPage"
import { searchParams } from "../../../helpers/search-params"

const defaultFormData: SignupFormData = {}

type RouteParams = {
    form: {
        edit: string
    }
}

export type SignupRouteParams = {
    onNavigateTo: (newRoute: SignupRoute, routeParams?: RouteParams) => void
    routeParams?: RouteParams
    orderId?: string
}

enum SignupRoute {
    Introduction,
    Disclaimer,
    Draft,
    Form,
    Review,
    TermsAndConditions,
    Acknowledgement,
    Payment,
    MyInfoCallback,
}

function SignupFlow() {
    const [myInfo, setMyInfo] = useState(defaultMyInfoData)
    const [route, setRoute] = useState<SignupRoute>(SignupRoute.Introduction)
    const [routeParams, setRouteParams] = useState<RouteParams>()

    useEffect(() => {
        const campaignCode = searchParams.CampaignCode
        if(campaignCode) {
            window.myNtucConfig.campaignCode = campaignCode
        }
    }, [])

    useEffect(() => {
        if (window.myNtucConfig.myInfoCallbackUrl != null && window.location.href.startsWith(window.myNtucConfig.myInfoCallbackUrl)) {
            setRoute(SignupRoute.MyInfoCallback)
        }
        else if (window.myNtucConfig.signupPaymentCallbackUrl != null && window.location.href.startsWith(window.myNtucConfig.signupPaymentCallbackUrl)) {
            setRoute(SignupRoute.Acknowledgement)
        }
    }, [])

    const defaultMyInfo = {
        myInfoData: myInfo,
        setMyInfoData: setMyInfo,
    }

    const handleNavigateTo = (newRoute: SignupRoute, routeParams?: RouteParams) => {
        window.scrollTo(0, 0)
        setRoute(newRoute)
        setRouteParams(routeParams)
    }

    const currentPage = () => {
        // ///////////////
        // //
        // return <SignupFormPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
        // //
        // ///////////////

        switch (route) {
            case SignupRoute.Introduction:
                return <IntroductionPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.Disclaimer:
                return <DisclaimerPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.Form:
                return <SignupFormPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.Review:
                return <ReviewPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.TermsAndConditions:
                return <TermsAndConditionsPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.Acknowledgement:
                return <AcknowledgementPage onNavigateTo={handleNavigateTo} />
            case SignupRoute.Payment:
                return <PaymentPage />
            case SignupRoute.MyInfoCallback:
                return <CallbackPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case SignupRoute.Draft:
                return <DraftPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
        }
    }

    return (
        <I18nextProvider i18n={i18config}>
            <ThemeProvider theme={theme}>
                <Container sx={{ backgroundColor: `white` }}>
                    <SignupFormContext.Provider value={defaultFormData}>
                        <StoreProvider initialState={initialState} reducer={signupReducer}>
                            <MyInfoContextProvider.Provider value={defaultMyInfo}>
                                {currentPage()}
                            </MyInfoContextProvider.Provider>
                        </StoreProvider>
                    </SignupFormContext.Provider>
                </Container>
            </ThemeProvider>
        </I18nextProvider>
    )
}

export {
    SignupRoute,
}

export default SignupFlow
